import { Component } from '@nicolas-riciotti/light2';

export default class BlockWidget extends Component {
  attached() {
    // The template holds the pasted document base64-encoded, so WP content
    // filters (wptexturize, wpautop) can't corrupt it. Decode as UTF-8.
    const template = this.querySelector('template[data-widget-html]');
    const encoded = template ? template.content.textContent.trim() : '';
    if (!encoded) return;

    const html = new TextDecoder().decode(
      Uint8Array.from(atob(encoded), (c) => c.charCodeAt(0))
    );
    if (!html.trim()) return;

    const title = this.getAttribute('data-title') || 'Embedded widget';

    let iframe = null;
    let built = false;

    // Appended to the pasted document so the sandboxed iframe reports its
    // content height. srcdoc + sandbox pages have a null origin, so the
    // message targets '*' and is matched back to this block by window
    // identity in handleMessage.
    const RESIZE_SNIPPET = '<script>(function(){var d=document.documentElement,p=function(){parent.postMessage({source:"block-widget",type:"height",height:d.scrollHeight},"*")};new ResizeObserver(p).observe(d);addEventListener("load",p)})()<\/script>';

    const handleMessage = (event) => {
      if (!iframe || event.source !== iframe.contentWindow) return;

      const data = event.data;
      if (!data || data.source !== 'block-widget' || data.type !== 'height') return;

      // Clamp so a buggy or hostile widget can't blow the page layout up.
      const height = Math.min(Math.ceil(data.height), 10000);
      iframe.style.height = `${height}px`;
    };

    const build = () => {
      if (built) return;
      built = true;

      this.style.display = 'block';
      this.style.width = '100%';

      iframe = document.createElement('iframe');
      // SECURITY: 'allow-scripts' WITHOUT 'allow-same-origin' is the entire
      // security model here — pasted code runs in a null origin with no access
      // to the site's cookies, session, or DOM. Never add 'allow-same-origin':
      // combined with srcdoc it makes pasted code same-origin with the site,
      // i.e. full XSS.
      iframe.setAttribute('sandbox', 'allow-scripts');
      iframe.setAttribute('title', title);
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('referrerpolicy', 'no-referrer');
      iframe.style.cssText = 'display:block;width:100%;height:0;border:0;overflow:hidden;';
      iframe.srcdoc = html + RESIZE_SNIPPET;

      this.appendChild(iframe);
    };

    window.addEventListener('message', handleMessage);

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !built) {
        observer.disconnect();
        build();
      }
    }, {
      threshold: 0.01,
      rootMargin: '0px 0px 300px 0px',
    });

    observer.observe(this);

    this._blockWidgetCleanup = () => {
      observer.disconnect();
      window.removeEventListener('message', handleMessage);
    };
  }

  detached() {
    if (this._blockWidgetCleanup) {
      this._blockWidgetCleanup();
      this._blockWidgetCleanup = null;
    }
  }
}

customElements.define('block-widget', BlockWidget);
